<template>
  <nav class="s-mobile-menu">
    <router-link :to="{ name: 'batteries' }">
      <i class="u-font-size-large icofont-ui-battery"></i>
      <div>{{ $t("navigation.batteries") }}</div>
    </router-link>
    <router-link :to="{ name: 'main-projects' }" class="u-margin-right">
      <i class="u-font-size-large icofont-architecture"></i>
      <div>{{ $t("navigation.projects") }}</div>
    </router-link>
    <span @click="showMobileDrawer = true" class="s-mobile-menu__bigger">
      <i class="icofont-plus"></i>
    </span>
    <router-link :to="{ name: 'cycles' }" class="u-margin-left">
      <i class="u-font-size-large icofont-recycle-alt"></i>
      <div>{{ $t("navigation.cycles") }}</div>
    </router-link>
    <router-link :to="{ name: 'admins' }">
      <i class="u-font-size-large icofont-users"></i>
      <div>{{ $t("navigation.admins") }}</div>
    </router-link>
    <Drawer v-model="showMobileDrawer" align="bottom">
      <MobileMenuDrawer
        @show:menu="showMobileDrawer = $event"
      ></MobileMenuDrawer>
    </Drawer>
  </nav>
</template>

<script>
import Drawer from "@/components/Base/Drawer.vue";
import MobileMenuDrawer from "./MobileMenuDrawer.vue";
export default {
  components: {
    Drawer,
    MobileMenuDrawer,
  },
  data() {
    return {
      showMobileDrawer: false,
      selectedEmployee: null,
    };
  },
};
</script>

<style></style>
